import * as React from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BasePage } from '../../reusableComponents/BasePage';
import { Async } from '../../reusableComponents/Async';
import { Loader } from '../../reusableComponents/Loader';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { AllMonthlyPPM1 } from '../../../constants/generals';
import { DailyFormsModel, IDailyFormsModelProps } from '../../../model/DailyFormModel';
import { getDailyFormDetails, getPlantPreventiveFormDetails } from '../../../services/dailyFormService';
import { Col, Row } from 'react-bootstrap';
import { QuestionModel } from '../../../model/QuestionModel';
import { pdfMaker } from '../../../services/formService';
export interface IDetailsPagePlantPreventive {
    id: string;
    instance: QuestionModel;
    detailsData: DailyFormsModel;
    region?; string;
    plantId?: string; 
    date?: string;
    userName?: string;
}
export interface IDetailsPagePlantPreventiveState {
    needsWorkData: any;
    okData: any;
}
export class DetailsPagePlantPreventiveImpl extends React.Component<IDetailsPagePlantPreventive, 
IDetailsPagePlantPreventiveState> {
    constructor(props: IDetailsPagePlantPreventive) {
        super(props);
        this.state = {
            needsWorkData: null ,
            okData: null,
        };
    }

    promise = async () => {
        await getPlantPreventiveFormDetails(this.props.id);
    }

    renderMarkAsCompleteButton = () => {
        if (!this.props.instance) {
            return <span />;
        }
        return <div style={{
            position: 'absolute',
            right: '20px',
        }}
            className="button"
            onClick={this.handlePrint}
            id="print-button" >
            <i className="fa fa-print" aria-hidden="true"></i>
            &nbsp;
                <span> Print</span>
        </div>;
    }
    
    handlePrint = () => {
        const { region, plantId, date, userName  } = this.props;
        pdfMaker(this.props.instance.props, region, plantId, date, userName);
    }

    renderXHeader = () => {
        return (
            <Row className="form-list-item" >
            <Col
                
                className="headings-plantPreventive"
                sm={5}
                xs={5}
            >
                Inspection Area
            </Col>
            <Col
                className="headings-plantPreventive"
                xs={5}
                sm={5}
            >
                Needs Work
            </Col>
            
            <Col
                className="headings-plantPreventive"
                xs={2}
                sm={2}
            >
                Ok
            </Col>
           
        </Row>    
        );
    }
    renderQuestions = (type, answer, question, customLabel) => {

        switch (type) {
            case 'YesNoTypeComment':
                return (
                    <Row className="form-list-item-question" >
            <Col
                
                id="question"
                className="question-plantPreventive"
                sm={5}
                xs={5}
            >
                {customLabel})&nbsp;{question}
            </Col>
            <Col
                className="question-plantPreventive needs-work"
                xs={5}
                sm={5}
            >
                { answer !== 'Ok' ? answer :  ''}
            </Col>
            
            <Col
                className="question-plantPreventive ok"
                xs={2}
                sm={2}
            >
             { answer === 'Ok' ? answer : ''}

            </Col>
            </Row>
                );
                case 'subQuestions':
                return (
                    <Row className="form-list-item-subQuestion" >
            <Col
                
                className="subQuestion-plantPreventive"
                sm={5}
                xs={5}
            >
                {customLabel})&nbsp;{question}
            </Col>
            <Col
                className="subQuestion-plantPreventive needs-work"
                xs={5}
                sm={5}
            >
                { answer !== 'Ok' ? answer :  ''}
            </Col>
            
            <Col
                className="subQuestion-plantPreventive ok"
                xs={2}
                sm={2}
            >
             { answer === 'Ok' ? answer : ''}

            </Col>
            </Row>
                );
        case 'title' :
                return (
                    <Row className="form-list-item-title" >
            <Col
                
                className="main-title-plantPreventive"
                sm={12}
                xs={12}
            >
                {question}
            </Col>
            
            </Row>
                );
        case 'headingForSubsections' :
        return (
            <Row className="form-list-item-headingforsubsection" >
    <Col
        
        className="sub-title-plantPreventive"
        sm={12}
        xs={12}
    >
        {customLabel})&nbsp;{question} :
    </Col>
    
    </Row>
        );
        default:
              return <div></div>;
        } 
    }
    renderTopDetails = () => {
        const { region, plantId, date, userName  } = this.props;
        return (
            <div className="top-details">
                <div style={{ fontSize: '15px' }}>
                    <span>Plant Region: </span>
                    <span style={{ color: 'rgb(164, 191, 67)' }}>&nbsp;{region}</span>
                </div>
                <div style={{ fontSize: '15px' }}>
                    <span>Plant Number: </span>
                    <span style={{ color: 'rgb(164, 191, 67)' }}>&nbsp;{plantId}</span>
                </div>
                <div style={{ fontSize: '15px' }}>
                    <span>Date </span>
                    <span style={{ color: 'rgb(164, 191, 67)' }}>&nbsp;{date}</span>
                </div>
                <div style={{ fontSize: '15px' }}>
                    <span>Inspected By </span>
                    <span style={{ color: 'rgb(164, 191, 67)' }}>&nbsp;{userName}</span>
                </div>
            </div>
        );
    }   
    renderFormDetails = () => {
        const { instance } = this.props;
        const firsHalfQuestions = instance && instance.props.questions.slice(0, 38);
        const otherHalfQuestions = instance && instance.props.questions.slice(38);
        if (!instance || !instance) {
            return <div></div>;
        }
        return <div id="details-page" className="details-page-container-plant-preventive landscape">
                    <PerfectScrollbar>
                        {this.renderTopDetails()}

                        <Row >
                                <Col className="row-wrapper"
                                    sm={6}
                                    xs={6} >
                                    {this.renderXHeader()}
                                {firsHalfQuestions.map((question) => (
                                    this.renderQuestions(question.Questiontype, 
                                        question.answer, question.question, question.customLabel)
                                )) }
                                </Col>
                                
                                <Col
                                    sm={6}
                                    xs={6} >
                                    {this.renderXHeader()}
                                {otherHalfQuestions.map((question) => (
                                    this.renderQuestions(question.Questiontype, 
                                        question.answer, question.question, question.customLabel)
                                )) }
                                </Col>
                            </Row>
                        <React.Fragment>
                                <Row className="" >
                                    <Col className="comment-section-plantPreventive" sm={12} xs={12}>
                                        {otherHalfQuestions[37].question}:
                                    </Col>
                                </Row>
                                <Row className="" >
                                    <Col className="comment-section-answer-plantPreventive" sm={12} xs={12}>
                                        {otherHalfQuestions[37].answer}
                                    </Col>
                                </Row>
                        </React.Fragment>
                        </PerfectScrollbar>
                </div >;
    }

    render() {
        return(
            <BasePage sideButton={this.renderMarkAsCompleteButton()} pageTitle="Plant Preventive Form Details" >
            <Async
                identifier="DetailsPageWrapper"
                promise={this.promise}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
                content={this.renderFormDetails()}
            />
        </BasePage>
        );
    }
}
export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const region = ownProps.match.params.region;
    const plantId = ownProps.match.params.plantId;
    const date = ownProps.match.params.date;
    const userName = ownProps.match.params.username;
    const instance = QuestionModel.get(id);
    const detailsData = DailyFormsModel.get(id);
    return {
        instance, id, detailsData, region, plantId, date, userName
    };
}
export const DetailsPagePlantPreventive = 
connect<{}, {}, IDetailsPagePlantPreventive>(mapStateToProps)(DetailsPagePlantPreventiveImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Daily/DetailsPagePlantPreventive.tsx